/**
 * 顶部提示
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';

import Notice from '@/components/Reservation/Notice';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reservation/createReserve';

const stateSelector = (state: ReducerState) => {
  const { roomNoticeData } = state;
  return roomNoticeData;
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  const { type, message } = props;

  return <Notice type={type} message={message} />;
};

export default connect<MapStateProps, MapDispatchProps>(mapStateToProps)(memo(Index));
